import React from 'react'
import {seoPageChange} from '../../utils'

class UpdateEntry extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() { seoPageChange() }

  render() {

    const { version, date } = this.props;

    return (
      <section className="UpdateEntry grid-row update-item">
        <a name={version}></a>
        <div className="grid-item update-item-title">
          <div className="header">{version}</div>
          {date && (
            <div className="date">{date}</div>
          )}
        </div>
        <div className="grid-item-4 ">
          <div className="markdown">
            {this.props.children}
          </div>
        </div>
      </section>
    )
  }

}

export default UpdateEntry;



// WEBPACK FOOTER //
// ./src/components/marketing/UpdateEntry.js